import { useRef } from 'react'
import { View } from 'react-native'
import { useStore } from '../models'
import { TableTourStepsPositionKey } from '../models/game/game-walkthrough'

interface UseTableTourPositioningProps {
  key: TableTourStepsPositionKey
  shouldSave?: () => boolean
}

export const useTableTourPositioning = ({ key, shouldSave }: UseTableTourPositioningProps) => {
  const {
    game: { addTableTourTargetPosition }
  } = useStore()
  const ref = useRef<View>(null)

  const onLayout = () => {
    ref.current?.measure((x, y, width, height, pageX, pageY) => {
      if (shouldSave && !shouldSave()) return
      if (!(width && height && pageX && pageY)) {
        return
      }
      addTableTourTargetPosition(key, { x: pageX, y: pageY, width, height })
    })
  }

  return { ref, onLayout }
}
